export default "__VITE_ASSET__CInj39qr__"